import { useEffect } from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import CustomAppBar from "../customAppBar";
import SideNavigation from "../sideNavigation";
import { useDashContext } from "../../context/DashboardContext";
import { useTenant } from "../../hooks/useTenant";
import Overview from "./overview";
import Appointments from "./appointments";
import Barbers from "./barbers";
import Clients from "./clients";
import Services from "./services";
import Schedule from "./shedule";
import Settings from "./settings";
import Analytics from "./analytics";
import AdminProfile from "./adminProfile";

const SLUG_TO_TAB = {
  overview: "Overview",
  appointments: "Appointments",
  services: "Services",
  schedule: "Schedule",
  barbers: "Barbers",
  clients: "Clients",
  analytics: "Analytics",
  settings: "Settings",
  profile: "Profile",
};

const AdminDashboard = () => {
  const { tenant } = useTenant();
  const { selectedTab, setSelectedTab } = useDashContext();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const slug = location.pathname.split("/")[2];
    if (!slug || !SLUG_TO_TAB[slug]) {
      navigate("/dashboard/overview", { replace: true });
      return;
    }
    setSelectedTab(SLUG_TO_TAB[slug]);
  }, [location.pathname]);

  const renderContent = () => {
    switch (selectedTab) {
      case "Appointments":
        return <Appointments />;
      case "Services":
        return <Services />;
      case "Schedule":
        return <Schedule />;
      case "Barbers":
        return <Barbers />;
      case "Clients":
        return <Clients />;
      case "Analytics":
        return <Analytics />;
      case "Settings":
        return <Settings />;
      case "Profile":
        return <AdminProfile />;
      default:
        return <Overview />;
    }
  };

  return (
    <>
      <CustomAppBar tenant={tenant} showLoginButton={false} />

      <Box
        sx={{
          mt: "64px",
          display: "flex",
          flexDirection: "row",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            width: "250px",
            flexShrink: 0,
            position: "sticky",
            top: "64px",
            height: "calc(100vh - 64px)",
            overflowY: "auto",
          }}
        >
          <SideNavigation />
        </Box>

        <Box sx={{ flex: 1, minWidth: 0 }}>{renderContent()}</Box>
      </Box>
    </>
  );
};

export default AdminDashboard;
